import { Injectable } from '@angular/core';
import { ArticleRequest } from '@core/interfaces/article-request.interface';
import { ApiService } from '@core/services/api.service';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { Observable } from 'rxjs';
import { ArticleProperty, ArticleType, Auction, CertificateType } from '../interfaces/auction.interface';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  constructor(private _api: ApiService) {}

  getTypes(): Observable<ArticleType[]> {
    return this._api.request(ApiServiceHolder.article.getTypes());
  }

  getAllCertificateTypes(): Observable<CertificateType[]> {
    return this._api.request(ApiServiceHolder.article.getAllCertificateTypes());
  }

  getProperties(iDArticleType: number): Observable<ArticleProperty[]> {
    return this._api.request(ApiServiceHolder.article.getProperties(iDArticleType));
  }

  getArticleByCertificate(certificate: string): Observable<Auction> {
    return this._api.request(ApiServiceHolder.article.getArticleByCertificate(certificate));
  }

  save(item: ArticleRequest): Observable<ArticleRequest> {
    return this._api.request(ApiServiceHolder.starredarticle.save(item));
  }

  delete(item: ArticleRequest): Observable<ArticleRequest> {
    return this._api.request(ApiServiceHolder.starredarticle.delete(item));
  }
  
}
